import { render } from "./CrashFilePage.vue?vue&type=template&id=1d0915e8&ts=true"
import script from "./CrashFilePage.vue?vue&type=script&lang=ts"
export * from "./CrashFilePage.vue?vue&type=script&lang=ts"

import "./CrashFilePage.vue?vue&type=style&index=0&id=1d0915e8&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__